export enum OracleEvents {
  SEND_MESSAGE = 'send_message',
  MESSAGE_RECEIVED = 'message_received',
  FIRST_MESSAGE_EVENT = 'first_message_event',
  BOOTCAMP_LINK_RECEIVED = 'bootcamp_link_received',
  ENCYCLOPEDIA_LINK_RECEIVED = 'encyclopedia_link_received',
  CURRICULUM_LINK_RECEIVED = 'curriculum_link_received',
  STANDALONE_LINK_RECEIVED = 'standalone_link_received',
  RATE_LIMIT_HIT = 'rate_limit_hit',
  UNAUTHORIZED = 'unauthorized',
  NETWORK_ERROR = 'network_error',
  UNEXPECTED_ERROR = 'unexpected_error',
  DRAG_WINDOW_FINISHED = 'drag_window_finished',
  RESIZE_WINDOW_FINISHED = 'resize_window_finished',
  CLICKED_ORACLE = 'click_oracle',
}

export enum OracleButtonClickTypes {
  ORACLE_ICON = 'oracle_icon',
  EXIT_ORACLE = 'exit_oracle',
  SUBSCRIBE = 'subscribe',
  BOOTCAMP_LINK = 'bootcamp_link',
  ENCYCLOPEDIA_LINK = 'encyclopedia_link',
  CURRICULUM_LINK = 'curriculum_link',
  STANDALONE_LINK = 'standalone_link',
  INTRO_ASK_ORACLE = 'intro_ask_oracle',
  INTRO_LEARNING_PATH = 'intro_learning_path',
  MINIMIZE_WINDOW = 'minimize_window',
}
